/* Loading placeholder for the warm-editorial surfaces (cream/ink
 * scale). The legacy `.skeleton` class in index.css stays slate-toned
 * for the dashboard; this primitive is the public-pages counterpart.
 *
 * Static ink-tint block under prefers-reduced-motion; the shimmer
 * sweep only runs behind motion-safe. The gradient paints ON TOP of
 * the persisting bg-ink/5, so its stops are transparent -> ink/5 ->
 * transparent: resting tint stays exactly bg-ink/5 for both cohorts
 * and only the sweep band reads darker. Decorative by design — wrap
 * the loading region in an element with role="status" + an accessible
 * label at the call site.
 */
const BASE =
  'bg-ink/5 motion-safe:animate-shimmer motion-safe:bg-gradient-to-r ' +
  'motion-safe:from-transparent motion-safe:via-ink/5 motion-safe:to-transparent motion-safe:bg-[length:200%_100%]';

export default function Skeleton({ className = '', rounded = 'rounded-xl', ...props }) {
  return <div aria-hidden="true" className={`${BASE} ${rounded} ${className}`} {...props} />;
}
